import { useTranslation } from "react-i18next";
import React from "react";
import CertificateSectionDesc from "./certificate-section-desc";
import { DownloadIcon } from "./downloadIcon";
import {
  CertificateWrapper,
  ButtonWrapper,
  DownloadCertificateButton,
} from "../styles"; // Update path accordingly
import { useCertificateContext } from "@root/context/certificate-context";
import { Spinner, Image, Box } from "@chakra-ui/react";
import useMediaQ from "@root/hooks/useMediaQ";
import defaultThumbnail from "@root/assets/images/Course Thunbnail.png";
import MobileCertificateSection from "./MobileCertificateSection";

const DEFAULT_THUMBNAIL = defaultThumbnail;

interface CertificateSectionProps {
  certificate: {
    course?: {
      thumbnail?: string;
      description?: string;
      updatedAt?: string;
      id?: string;
    };
  } | null;
}

const CertificateSection: React.FC<CertificateSectionProps> = ({
  certificate,
}) => {
  const { fetchCertificate, isCourseLoading, isCertificateLoading } =
    useCertificateContext();
  const { t } = useTranslation("common");
  const { sm } = useMediaQ();
  const isMobile = !sm;

  // Null check for safety
  if (!certificate) return null;

  if (isMobile) {
    return <MobileCertificateSection certificate={certificate} />;
  }

  // Desktop version
  return (
    <CertificateWrapper height={"100%"}>
      <Box
        w="180px"
        h="120px"
        flexShrink={0}
        borderRadius="9px"
        overflow="hidden"
      >
        <Image
          src={certificate?.course?.thumbnail || DEFAULT_THUMBNAIL}
          borderRadius="9"
          w="100%"
          h="100%"
          objectFit="contain"
        />
      </Box>

      <CertificateSectionDesc course={certificate?.course} />

      <ButtonWrapper>
        <DownloadCertificateButton
          onClick={() =>
            fetchCertificate({
              courseId: certificate?.course?.id,
              gmtOffset: 0,
            })
          }
          isLoading={isCertificateLoading(certificate?.course?.id)}
          loadingText={t("certificateSection.download")}
          disabled={isCertificateLoading(certificate?.course?.id)}
        >
          {isCertificateLoading(certificate?.course?.id) ? (
            <Spinner size="sm" />
          ) : (
            <DownloadIcon boxSize={4} />
          )}
          {t("certificateSection.download")}
        </DownloadCertificateButton>
      </ButtonWrapper>
    </CertificateWrapper>
  );
};

export default CertificateSection;
